import {Component, ViewChild, OnInit} from '@angular/core';
import {DataSource} from '@angular/cdk/collections';
import {MdPaginator, DateAdapter} from '@angular/material';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import { FormsModule } from "@angular/forms";
import { MdSnackBar, MdDialog } from '@angular/material';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { BrogliaccioDistintaModel } from './../../models/brogliacci/brogliaccio-distinta.model';
import { BrogliacciService } from './../../services/brogliacci.service';
import { BrogliaccioSearchModel } from "../../models/brogliacci/brogliaccio-search.model";
import { DizionarioModel } from "../../models/shared/dizionario.model";
import { IncassiService } from "../../services/incassi.service";
import { UltimaVersioneApplicativoClientService } from '../../services/ultima-versione-applicativo-client.service';
import { Configurations } from '../../core/configurations';

@Component({
  selector: 'app-brogliacci-list',
  templateUrl: './brogliacci-list.component.html',
  styleUrls: ['./brogliacci-list.component.css']
})

export class BrogliacciListComponent implements OnInit {
  isLoading: boolean;
  displayedColumns = ['id', 'dataCreazione', 'stato', 'totaleValuta', 'totaleAssegni','dataPresaInCarico','tokenDettagli','tokenElimina'];
  dataSource: BrogliacciDataSource | null;
  brogliacci: BrogliaccioDistintaModel[];
  modelSearch: BrogliaccioSearchModel = null;
  STATI_BROGLIACCIO: DizionarioModel[];
  dataDal?: Date;
  dataAl?: Date;

  constructor(
    private snackBar: MdSnackBar,
    private _brogliacciService: BrogliacciService,
    private _incassiService: IncassiService,
    private _dateAdapter:DateAdapter<Date>,
    private _ultimaVersioneClientTipo: UltimaVersioneApplicativoClientService

  ) {
    this._dateAdapter.setLocale('it-IT');
   }

  
    @ViewChild(MdPaginator) paginator: MdPaginator;

    ngOnInit() {
      //alert("pagina lista brogliacci");
      this._ultimaVersioneClientTipo.getUltimaVersioneApplicativo()
      .subscribe(data => {
        Configurations.currentVersionCod=data.codice;
        let v=localStorage.getItem('clientVersion');
        if(v===null||v===undefined||v!==data.codice) {
          localStorage.setItem('clientVersion',data.codice);
          alert("Sono state pubblicate delle modifiche nel portale, per poterle caricare verrà indirizzato alla homepage.");
          window.location.href=Configurations.baseUrl;
          
        }
      });
      this.modelSearch = new BrogliaccioSearchModel();
      let emptyChoice=new DizionarioModel();
      emptyChoice.codice="";
      emptyChoice.descrizione="Tutti";
      this._brogliacciService.getStati().subscribe(
        data => {
          data.splice(0,0,emptyChoice);
          this.STATI_BROGLIACCIO = data;
        },
        error => {
          this.showError("Errore durante la procedura di caricamento degli stati");
        }
      );
      initDatePicker();
      
      //fai vedere subito i nuovi
      this.modelSearch.idstato=1;
      this.isLoading= true;
      this.dataSource = new BrogliacciDataSource(this._brogliacciService, this.paginator, this.modelSearch,this);
    }
   
    /* RICERCA */
    search() {
      this.modelSearch.dataAl= this.dataAl;
      this.modelSearch.dataDal= this.dataDal;
      this.isLoading= true;
      this.dataSource = new BrogliacciDataSource(this._brogliacciService, this.paginator, this.modelSearch,this);
      
    }

    /* ELIMINAZIONE DI UN BROGLIACCIO */
    EliminaBrogliaccio(model: BrogliaccioDistintaModel) {
      //elimino il brogliaccio (dalla lista)
      this._brogliacciService.eliminaBrogliaccio(model.token).subscribe(
        data => {
          this.showInfo("Eliminazione avvenuta correttamente");
          this.search();
        },
        error => {
          this.showError("Errore durante la procedura di eliminazione del brogliaccio");
          return false;
        }
      );
      
    }


  private showError(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 4000 });
  }

  private showInfo(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 4000 });
  }
  public getFilteredBrogliacci(model:BrogliacciDataSource): Observable<BrogliaccioDistintaModel[]> {
    let result = this._brogliacciService.getFilteredList(this.modelSearch);
    result.subscribe(
      data=> {
        this.isLoading=false;
      }
    );
    return result;
  }
}



/* DATA SOURCE - lista brogliacci */
export class BrogliacciDataSource extends DataSource<any> {
  data: Observable<BrogliaccioDistintaModel[]>;
  constructor(private _brogliaccioService: BrogliacciService, private _paginator: MdPaginator, 
    private modelSearch: BrogliaccioSearchModel, public originModel:BrogliacciListComponent) {
    super();
  }
  connect(): Observable<BrogliaccioDistintaModel[]> {
    
    // this.data =  this._brogliaccioService.getFilteredList(this.modelSearch);
    // if(this.brogliacciComponent!=null){
    //   this.brogliacciComponent.isLoading=false;
    // }
    return this.originModel.getFilteredBrogliacci(this);

  }
  disconnect() {}

}




// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/brogliacci/brogliacci-list.component.ts